var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.47342C14.5 1.19728 14.2761 0.973422 14 0.973421L9.49997 0.973421C9.22383 0.973421 8.99997 1.19728 8.99997 1.47342C8.99997 1.74956 9.22383 1.97342 9.49997 1.97342L13.5 1.97342L13.5 5.97342C13.5 6.24956 13.7238 6.47342 14 6.47342C14.2761 6.47342 14.5 6.24956 14.5 5.97342L14.5 1.47342ZM1.30033 14.8802L14.3535 1.82697L13.6464 1.11987L0.593224 14.1731L1.30033 14.8802Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow 1.01c0efaf79efdff1f6e8bda72007c750.svg";
export { ForwardRef as ReactComponent };